<template>
  <v-container>
    <v-row>
      <v-col v-for="(labelProcedimiento, idProcedimiento) in TIPOS_PROCEDIMIENTOS" :key="idProcedimiento">
        <v-card elevation="4" class="rounded-sm">
          <v-card-title>
            <div class="text-h6">{{ procedimientosCounters[idProcedimiento] }} {{ labelProcedimiento }}</div>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
const TIPOS_PROCEDIMIENTOS = {
  1: 'Queja(s)',
  2: 'Administrativo(s)',
  3: 'Averiguacion(es) previa(s)',
  4: 'Carpeta(s) de investigación',
}

export default {
  props: {
    procedimientos: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      TIPOS_PROCEDIMIENTOS,
    }
  },

  computed: {
    procedimientosCounters() {
      const counters = {}
      Object.keys(this.TIPOS_PROCEDIMIENTOS).forEach((idProcedimiento) => {
        const id = parseInt(idProcedimiento)
        counters[id] = this.procedimientos.filter(({ idProcedimiento }) => idProcedimiento === id).length
      })
      return counters
    },
  },
}
</script>
